import { createSelector } from '@reduxjs/toolkit';

import { isTeamingInProgressSelector } from 'features/teaming/teaming-base/store';
import { selectIsViConnectedToFreeSwitchConference } from 'features/caller-session/store';
import { isWavelloCallActiveSelector } from 'features/call/call-hearing/store';

export const selectIsForkingAllowed = createSelector(
  isTeamingInProgressSelector,
  selectIsViConnectedToFreeSwitchConference,
  isWavelloCallActiveSelector,
  (isTeamingInProgress, isViInFreeSwitchRoom, isWavelloCallActive) =>
    !isTeamingInProgress && !isViInFreeSwitchRoom && !isWavelloCallActive
);
